import { render } from "./imgBox.vue?vue&type=template&id=c5763030&scoped=true"
import script from "./imgBox.vue?vue&type=script&lang=js"
export * from "./imgBox.vue?vue&type=script&lang=js"

import "./imgBox.vue?vue&type=style&index=0&id=c5763030&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c5763030"

export default script